<template>
  <div>
    <div class="form-control-group">
      <div class="form-control form-pikerbox" readonly>
        <ul class="form-pikerbox-main" v-if="selectData&&selectData.length>0" @click="onSelectDepartment">
          <li v-for="(item,index) in selectData" :key="index" :title="getDeptName(item)">
            {{getDeptName(item)}}
            <i class="fa fa-remove" @click.stop="selectData.splice(index,1)"></i>
          </li>
        </ul>
        <div class="form-control-placeholder" @click="onSelectDepartment" v-else>{{placeholder}}</div>
      </div>
      <i class="btn btn-default fa fa-sitemap" @click="onSelectDepartment"></i>
    </div>
    <Department-picker :only-dpet="onlyDpet" :first-dept="firstDept" :default-expanded-keys="defaultExpandedKeys" :top-dept-id="topDeptId" :checkStrictly="true" :checkedData="selectData" :multiple="multiple" @pickerCallBack="onDepartmentCallBack" v-if="visible"></Department-picker>
  </div>
</template>
<script>
import DepartmentPicker from "@/modules/sys/components/picker/department.vue";

export default {
  name: "Department-select",
  components: { DepartmentPicker },
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: "请选择人员"
    },
    showFullDeptname:{
      type:Boolean,
      default:false
    },
    topDeptId:{
       type: String,
       default: ""
    },
    defaultExpandedKeys:{
      type: Array,
      default(){
        return []
      }
    },
    firstDept:{
      type: Array,
      default(){
        return []
      }
    },
    onlyDpet:{
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectData: this.value,
      visible: false
    };
  },
  watch: {
    value(newVal) {
      this.selectData = newVal;
    },
    selectData: {
      handler(newVal) {
        this.$emit("input", newVal);
      },
      deep: true
    }
  },
  methods: {
    onSelectDepartment() {
      this.visible = true;
    },
    onDepartmentCallBack(res) {
      this.visible = false;
      if(!res)return
      if (this.multiple) {
        this.selectData = res
      } else {
        this.selectData = [res];
      }
      this.$emit("pickerSelectCallBack", this.selectData);
    },
    getDeptName(dept){
      if(this.showFullDeptname&&dept.data&&dept.data.FullDepartmentName){
        return dept.data.FullDepartmentName
      }
      return dept.text

    }
  } 
};
</script>

